/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeFilter_In } from '../models/EmployeeFilter_In';
import type { GetDashboard_In } from '../models/GetDashboard_In';
import type { GetDashboard_Out } from '../models/GetDashboard_Out';
import type { GetEmployeeHistory_Out } from '../models/GetEmployeeHistory_Out';
import type { GetEmployees_Out } from '../models/GetEmployees_Out';
import type { GetMultipleEmployees_Out } from '../models/GetMultipleEmployees_Out';
import type { RegisterEmployees_In } from '../models/RegisterEmployees_In';
import type { TransferEmployee_In } from '../models/TransferEmployee_In';
import type { TransferPoolEmployee_In } from '../models/TransferPoolEmployee_In';
import type { UpdateEmployee_In } from '../models/UpdateEmployee_In';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmployeesService {

    /**
     * Get All Employees
     * Get information about all employees for the current user organization
     * @param requestBody
     * @returns GetMultipleEmployees_Out Successful Response
     * @throws ApiError
     */
    public static getAllEmployees(
        requestBody: EmployeeFilter_In,
    ): CancelablePromise<GetMultipleEmployees_Out> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/employees/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Register Employees
     * Add multiple employees to the system
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static registerEmployees(
        requestBody: RegisterEmployees_In,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/employees/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Employee
     * Get information about a specific employee
     * @param employeeId
     * @returns GetEmployees_Out Successful Response
     * @throws ApiError
     */
    public static getEmployee(
        employeeId: string,
    ): CancelablePromise<GetEmployees_Out> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employees/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Employee
     * Update employee information
     * @param employeeId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateEmployee(
        employeeId: string,
        requestBody: UpdateEmployee_In,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/employees/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Employee
     * Delete an employee from the system
     * @param employeeId The id of the employee to delete
     * @returns void
     * @throws ApiError
     */
    public static deleteEmployee(
        employeeId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/employees/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Employee History
     * Get the history of a specific employee
     * @param employeeId The id of the employee to get history
     * @returns GetEmployeeHistory_Out Successful Response
     * @throws ApiError
     */
    public static getEmployeeHistory(
        employeeId: string,
    ): CancelablePromise<GetEmployeeHistory_Out> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employees/{employee_id}/history',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Dashboard
     * Get the dashboard data
     * @param requestBody
     * @returns GetDashboard_Out Successful Response
     * @throws ApiError
     */
    public static getDashboard(
        requestBody: GetDashboard_In,
    ): CancelablePromise<GetDashboard_Out> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/employees/dashboard',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Transfer Employee
     * Deploy an employee to a office
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static transferEmployee(
        requestBody: TransferEmployee_In,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/employees/transfer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Move Employee To Transfer State
     * Update information about a specific employee
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static moveEmployeeToTransferState(
        requestBody: TransferPoolEmployee_In,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/employees/eligible-for-transfer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Transfer To Other District
     * Update information about a specific employee
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static transferToOtherDistrict(
        requestBody: TransferPoolEmployee_In,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/employees/transfer-to-other-district',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}